import type { PaymentMethodType } from '../../../../../services/customer/types';
import type { FormattedPaymentMethod } from '../types/FormattedPaymentMethod';

import isManufacturerCard from './isManufacturerCard';
import isManufacturerCardCategoriesEmpty from './isManufacturerCardCategoriesEmpty';

export default function isPaymentMethodNotSelectable(
  isManufacturerCardEnabledForMerchant: boolean,
  formattedPaymentMethod: FormattedPaymentMethod<PaymentMethodType>,
) {
  const isManufacturerCardType =
    isManufacturerCard(formattedPaymentMethod) ||
    isManufacturerCardCategoriesEmpty(formattedPaymentMethod);

  return (
    !isManufacturerCardEnabledForMerchant &&
    isManufacturerCardType
  );
}
